/**
 * Created by guoyan on 2018/6/20.
 */
const market = {
  namespaced: true,
  state: {
  },
  actions: {
  },
  mutations: {
  }
}
export default market
